export default "__VITE_ASSET__DL50YzRU__"